import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, useQuery, API } from "../../../api";

export default function AgingSummary() {
  const [getReport, { data, loading }] = useLazyQuery(API.GET_AGING_SUMMARY, {
    fetchPolicy: "network-only",
  });
  const { data: routes } = useQuery(API.GET_ROUTES);

  const routeOptions = React.useMemo(
    () => routes?.result?.map((t) => ({ title: t?.name, value: t?._id })),
    [routes]
  );

  const [filters, setFilters] = React.useState({ route: "" });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const columns = [
    {
      name: "code",
      label: "Code",
      options: { align: "center" },
    },
    {
      name: "customer",
      label: "Customer",
      options: { align: "left", width: 300 },
    },
    {
      name: "1-15days",
      label: "1-15 Days",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "16-30days",
      label: "16-30 Days",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "31-45days",
      label: "31-45 Days",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "over45",
      label: "Over 45 Days",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "total",
      label: "Total",
      options: { align: "right", money: true, showTotal: true },
    },
  ];

  return (
    <Report
      title="Aging Summary"
      data={data}
      columns={columns}
      filters={[
        {
          type: "autocomplete",
          name: "route",
          label: "Route",
          options: routeOptions,
          value: filters?.route,
        },
      ]}
      onFiltersChange={(e) => setFilters((x) => ({ ...x, ...e }))}
    >
      <Table data={data} columns={columns} showTotals isLoading={loading} />
    </Report>
  );
}
